import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslate } from "@bluelibs/x-ui";
import * as Ant from "antd";
import { ApolloError, useLazyQuery } from "@apollo/client";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { FindCompanyTotalBalances } from "@bundles/UIAppBundle/queries/FindCompanyTotalBalances";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
dayjs.extend(relativeTime);
const ListTotalCompanyBalances = forwardRef(({ companyIds, bankAccountIds }, ref) => {
    var _a, _b, _c, _d;
    const t = useTranslate();
    const [data, setData] = useState({
        totalIncome: 0,
        totalExpense: 0,
        totalBalance: 0,
        futureBalance: 0,
    });
    const [fetchData] = useLazyQuery(FindCompanyTotalBalances, {
        variables: {
            input: {
                companyIds,
                bankAccountIds,
            },
        },
    });
    const fetchDatas = () => {
        fetchData({ variables: { input: { companyIds, bankAccountIds } } })
            .then((res) => {
            setData(res.data.FindCompanyTotalBalances);
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    };
    useImperativeHandle(ref, () => ({
        refetchData() {
            fetchDatas();
        },
    }));
    useEffect(() => {
        fetchDatas();
    }, [companyIds, bankAccountIds]);
    return (_jsx(Ant.Card, Object.assign({ className: "total-balances-container-table" }, { children: _jsxs(Ant.Layout.Content, Object.assign({ className: "total-company-balances-table-content" }, { children: [_jsxs(Ant.Card, Object.assign({ className: "total-card" }, { children: [_jsx("p", { children: t("dashboard.totalIncome") }, void 0), _jsx("div", { className: "border" }, void 0), _jsx("span", { children: `${((_a = data === null || data === void 0 ? void 0 : data.totalIncome) !== null && _a !== void 0 ? _a : 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} ${BankAccountCurrency.RON}` }, void 0)] }), void 0), _jsxs(Ant.Card, Object.assign({ className: "total-card" }, { children: [_jsx("p", { children: t("dashboard.totalExpense") }, void 0), _jsx("div", { className: "border" }, void 0), _jsx("span", { children: `${((_b = data === null || data === void 0 ? void 0 : data.totalExpense) !== null && _b !== void 0 ? _b : 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} ${BankAccountCurrency.RON}` }, void 0)] }), void 0), _jsxs(Ant.Card, Object.assign({ className: "total-card" }, { children: [_jsx("p", { children: t("dashboard.totalBalance") }, void 0), _jsx("div", { className: "border" }, void 0), _jsx("span", { children: `${((_c = data === null || data === void 0 ? void 0 : data.totalBalance) !== null && _c !== void 0 ? _c : 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} ${BankAccountCurrency.RON}` }, void 0)] }), void 0), _jsxs(Ant.Card, Object.assign({ className: "total-card" }, { children: [_jsx("p", { children: t("dashboard.futureBalance") }, void 0), _jsx("div", { className: "border" }, void 0), _jsx("span", { children: `${((_d = data === null || data === void 0 ? void 0 : data.futureBalance) !== null && _d !== void 0 ? _d : 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} ${BankAccountCurrency.RON}` }, void 0)] }), void 0)] }), void 0) }), void 0));
});
export default ListTotalCompanyBalances;
